import Vue from 'vue'
import Router from 'vue-router'

import { routes } from './routes'
import $store from '../store'
import * as authService from '../services/auth.service'
import * as userService from '../services/user.service'

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'is-active',
  mode: 'history',
  routes
})

/**
 * Initialize app state and check access
 */
function initAppStateMiddleware (to, from, next) {
  // app initialization for auth required routes
  if (to.matched.some(item => item.meta.isAuth)) {
    if (authService.getRefreshToken() && !$store.state.userData.id) {
      return authService.refreshTokens()
        .then(() => userService.getCurrent())
        .then(user => $store.commit('SET_USER', user.data))
        .then(() => next())
        .catch(error => console.log(error))
    }
    if ($store.state.userData.id) {
      return next()
    }
    return next({name: 'login'})
  }

  // app initialization for public routes
  if (authService.getRefreshToken() && !$store.state.userData.id) {
    return authService.refreshTokens()
      .then(() => userService.getCurrent())
      .then(user => $store.commit('SET_USER', user.data))
      .then(() => next())
      .catch(error => console.log(error))
  }

  next()
}

/**
 * Set <title></title> to each page
 */
function setPageTitleMiddleware (to, from, next) {
  const pageTitle = to.matched.find(item => item.meta.title)
  if (pageTitle) {
    window.document.title = pageTitle.meta.title
  }

  next()
}

router.beforeEach(setPageTitleMiddleware)
router.beforeEach(initAppStateMiddleware)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js